import { logger } from '../logger';
/**
 * @shm/interface need to be installed to use this collector
 */
export class SHMLogCollector {
    receive(events, commonParams) {
        const transformed = events.map((event) => {
            return Object.assign(Object.assign({}, commonParams), event);
        });
        transformed.forEach((item) => logger.debug('report event', 'event', item));
        return Promise.resolve();
    }
}
